module.exports = __webpack_public_path__ + "static/img/tm30_1.0269251.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tm30_1.png
// module id = WGbe
// module chunks = 16